/**
 * Generic dirty check for form snapshots.
 *
 * Compares a `current` snapshot against its `initial` baseline using a stable
 * JSON serialization. Works for any serializable snapshot shape `T` (plain
 * objects of scalars, nested records, arrays, etc.).
 *
 * Note: order of object keys matters for `JSON.stringify`, so always build the
 * `current` and `initial` snapshots with the same shape/key order (typically by
 * returning them from the same `getSnapshot` function).
 */
export function isFormValueDirty<T>(current: T, initial: T): boolean {
    return JSON.stringify(current) !== JSON.stringify(initial);
}
